<template>
  <div id="app">
    <div class="navigation">
      <TopNav
        class="top-nav"
        :fullname="fullname"
        :isAdmin="isAdmin"
        :isStandard="isStandard"
        :class="{ notShow: !isLoggedIn }"
      />
      <BottomNav
        v-on:openUploadModal="openUploadModal"
        class="bottom-nav"
        :class="{ notShow: !isLoggedIn }"
      />
    </div>
    <Upload
      v-bind:uploadModal="uploadModal"
      v-on:close-upload-modal="openUploadModal"
      v-on:close-on-uploaded="openUploadModal"
      v-on:closeUploadModal="openUploadModal"
      v-bind:categories="categories"
    />
    <router-view
      v-bind:categories="categories"
      v-bind:class="{ loggedOut: !isLoggedIn, currentView: isLoggedIn }"
    />
  </div>
</template>

<script>
import Upload from "./components/upload/Upload";
import TopNav from "./components/navigation/TopNav";
import BottomNav from "./components/navigation/BottomNav";
import db from "./components/firebase/init";
import firebase from "firebase/app";
import "firebase/auth";
import { getUserNameOffId } from "./components/mixins/getUserNameOffId";

export default {
  name: "App",
  components: {
    TopNav,
    BottomNav,
    Upload,
  },
  mixins: [getUserNameOffId],
  data() {
    return {
      isLoggedIn: null,
      fullname: null,
      isAdmin: null,
      isStandard: null,
      uploadModal: false,
      categories: [],
    };
  },
  beforeCreate() {},
  created() {
    this.userLoggedIn();
    this.fetchData();
    // this.getUserInfo();
  },
  methods: {
    userLoggedIn() {
      if (firebase.auth().currentUser) {
        this.isLoggedIn = true;
      }
    },
    getUserInfo() {
      if (firebase.auth().currentUser) {
        // if true, make request to data base to pull user information
        db.collection("users")
          .doc(firebase.auth().currentUser.uid)
          .get()
          .then((doc) => {
            this.id = doc.id;
            this.fullname = doc.data().fullname;
            this.isAdmin = doc.data().isAdmin;
            this.isStandard = true;
          });
      }
    },
    closeUploadModal() {
      this.$emit("closeUploadModal");
    },

    openUploadModal() {
      this.uploadModal = !this.uploadModal;
    },

    // method to get all the categories from the database
    // then uses pushes them to the array that is
    // then displayed to the page
    fetchData() {
      db.collection("category").onSnapshot((snap) => {
        snap.docChanges().forEach(async (docu) => {
          // if page is loading, all types will be added,
          // therefore all will be created and pushed to
          // the doc
          if (docu.type === "added") {
            const data = await {
              id: docu.doc.id,
              name: docu.doc.data().name,
              items: docu.doc.data().items,
              datemod: docu.doc.data().date.toDate(),
              createdby: await this.fetchName(docu.doc.data().createdBy),
            };
            await this.categories.push(data);
            // if the page is already rendered, and a document
            // is added or modified, it will pass here.
          } else if (docu.type === "modified") {
            const checkCat = await this.categories.filter(
              (docItem) => docItem.id === docu.doc.id
            );
            // if the document already exists, then just update
            // the number of items.
            if (checkCat.length > 0) {
              checkCat[0].items = docu.doc.data().items;
              // else if it is new categroy, create all fields
            } else {
              const data = await {
                id: docu.doc.id,
                name: docu.doc.data().name,
                items: docu.doc.data().items,
                datemod: docu.doc.data().date.toDate(),
                createdby: await this.fetchName(docu.doc.data().createdBy),
              };
              await this.categories.push(data);
            }
            // if we delete, then make this change locally
            // by filtering it out of the array on page.
          } else if (docu.type === "removed") {
            this.categories = this.categories.filter((docus) => {
              return docus.id != docu.doc.id;
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
* {
  font-family: "Quicksand", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.navigation {
  z-index: 99;
  position: fixed;
  width: 100%;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

#app {
  position: relative;
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
}

.currentView {
  margin-top: 155.38px;
}

body {
  background-color: #f1f1f1;
}

.notShow {
  display: none;
}

.container {
  width: 90%;
  margin: 0 auto;

  @media (min-width: 1200px) {
    width: 80%;
  }
}

// Category Defaults
.container-dashboard {
  height: 100%;
  background-color: white;

  .title {
    display: flex;
    align-items: center;
    font-size: 24px;
    padding: 40px 24px 24px;

    h2 {
      flex: 1;
    }

    i {
      transition: 500ms ease all;
      color: rgba(99, 56, 255, 1);
      cursor: pointer;
      font-size: 30px;
      margin-left: 16px;

      &:hover {
        color: rgba(99, 56, 255, 0.7);
      }
    }
  }
}

// Default Classes

.btn {
  transition: 500ms ease;
  cursor: pointer;
  border-radius: 4px;
  border: none;
  padding: 12px 0;
  width: 100%;
}

.link {
  text-decoration: none;
}

.mt-1 {
  margin-top: 1rem;
}

.purple {
  color: white;
  background-color: #6236ff;
}

.purple:hover {
  background-color: #6236ff77;
}
</style>
